import ServerError from 'govbr.frontend.policy/components/Errors/ServerError/ServerError';

export default ServerError;
